<template>
  <div class="settlement-box">
    <Table
      :loading="loading"
      border
      :columns="tableColumns"
      :no-data-text="noDataText"
      :data="tableData"
      :max-height="tableHeight + 10"
      @on-selection-change="onSelectionChange"
    >
      <template slot="orgName" slot-scope="{ row }">
        <TablePoptip :content="row.orgName"> </TablePoptip>
      </template>
      <template slot="schoolName" slot-scope="{ row }">
        <TablePoptip :content="row.schoolName"> </TablePoptip>
      </template>

      <template slot="approvalSts" slot-scope="{ row, index }">
        <span>{{ row.approvalSts | initApprovalSts }}</span>
      </template>
      <template slot="settleSts" slot-scope="{ row, index }">
        <span>{{ row.settleSts | initSettleSts }}</span></template>
      <template slot="bankId" slot-scope="{ row, index }">
        <span>{{ row.bankId | initBankId }}</span></template>
      <template slot="settleCycle" slot-scope="{ row, index }">
        <span>{{ row.settleCycle | initSettleCycle }}</span></template>

      <template slot="action" slot-scope="{ row, index }">
        <span
          class="click-btn-430"
          style="margin-right: 5px"
          @click="handleToDetails(row, index)"
        >查看详情</span>
        <span
          v-if="showAdminCfmBtn(row)"
          class="click-btn-430"
          @click="handleAdminCfm(row, index)"
        >提交运营确认</span>
      </template></Table>
    <AdminCheck
      ref="adminCheckRef"
      @on-uploadStaSts="onUploadStaSts"
    ></AdminCheck>
  </div>
</template>

<script>
import { getColumn } from '../data/SettlementTable';
import { mapState, mapActions } from 'vuex';
import orderCenterApi from '@/request/orderCenter/index.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import BigNumber from 'bignumber.js';
import AdminCheck from './AdminCheck.vue';
import { getApprovalSts } from '../data/utils';
export default {
  components: {
    AdminCheck
  },
  mixins: [mixinTableHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    searchParameter: {
      type: Object,
      default: () => { }
    },

    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // tableType: 1: 运营平台 - 机构端->机构 2:运营平台 - 学校端 ->学校 3:教育局
      tableType: this.$route.meta.tableType,
      tableColumns: getColumn(this.$route.meta.tableType),
      portOrg: localStorage.getItem('portOrg'),
      tables: [],
      noDataText: '暂无数据',
      selectionRows: []
    };
  },

  computed: {
    ...mapState(['theUserIdentity'])
  },
  watch: {
    tableData: {
      handler(newVal, oldVal) { },
      immediate: true,
      deep: true
    },
    searchParameter: {
      handler(newVal, oldVal) {

      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.initColumn();
  },
  mounted() {
    this.theUserIdentity === 'edu' ? this.noDataText = '账单待生成' : '';
    if (this.theUserIdentity == 'edu') {
      this.tableHeight = 550;
    }
  },
  methods: {
    ...mapActions('orderCenter', [
      'updateSettlementDetailsSearch'
    ]),
    onSelectionChange(rows) {
      this.selectionRows = rows;
    },
    // 运营端 显示确认按钮
    showAdminCfmBtn(row) {
      return this.tableType == 1 && this.portOrg == 0 && row.approvalSts == 1;
    },
    initColumn() {
      if (this.portOrg === '0' && this.tableType == 1) {
        this.tableColumns = [...getColumn(4)];
      } else {
        this.tableColumns = [...getColumn(this.tableType)];
      }
      if ((this.portOrg === '0' || this.portOrg === '2') && this.tableType == 2) {
        const index1 = this.tableColumns.findIndex(item => {
          return item.key === 'attachmentPrice';
        });
        this.tableColumns.splice(index1, 1, {
          title: '材料费-校内',
          key: 'attachmentPriceSch',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '材料费-机构',
          key: 'attachmentPriceOrg',
          minWidth: 130,
          align: 'center'
        });
        const index2 = this.tableColumns.findIndex(item => {
          return item.key === 'classroomFee';
        });
        this.tableColumns.splice(index2, 1, {
          title: '素质课程费-校内',
          key: 'classroomFeeSch',
          minWidth: 150,
          align: 'center'
        },
        {
          title: '素质课程费-机构',
          key: 'classroomFeeOrg',
          minWidth: 150,
          align: 'center'
        });
      }
    },

    getJmupData(row) {
      const { tableType, portOrg } = this.searchParameter;
      const data = JSON.parse(JSON.stringify(this.searchParameter.data));
      data.orgId = row.orgId;
      data.orgName = row.orgName;
      row.schoolId ? data.schId = row.schoolId : '';
      row.schoolName ? data.schName = row.schoolName : '';
      row.bankType ? data.bankId = row.bankType : '';

      return {
        data: { ...data },
        tableType,
        portOrg
      };
    },
    handleRoute(urlName, query) {
      // const routeUrl = this.$router.resolve({
      //   name: urlName,
      //   query: query
      // });

      // window.open(routeUrl.href, '_blank');
      this.$router.push({
        name: urlName,
        query: query
      });
    },
    // 运营提交
    handleAdminCfm(row) {
      this.$refs.adminCheckRef.handleShow({
        sheetId: row.sheetId,
        totalFee: row.settleAvailAmt,
        totalDivideAmt: row.merchantAmt
      });
      return null;
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否提交确认？</p>',
        onOk: () => {
          const settleAvailAmt = new BigNumber(row.settleAvailAmt.replace(/,/g, ''));
          this.$Spin.show();
          orderCenterApi.uploadStatementStsByAdmin({ statementId: row.statementId, orgId: row.orgId, settleAvailAmt: settleAvailAmt.times(100) * 1 }).then(res => {
            this.$Spin.hide();
            if (res.data.status == 200) {
              this.$Message.success('提交成功');
              this.$emit('on-uploadStaSts');
            } else if (res.data.status == 4802) {
              setTimeout(() => {
                this.$Modal.warning({
                  title: '温馨提示',
                  content: '账单数据已更变，请重新加载后再次确认!',
                  onOk: () => {
                    location.reload();
                  }
                });
              }, 500);
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    onUploadStaSts() {
      this.$emit('on-uploadStaSts');
    },
    handleToDetails(row) {
      if (this.tableType == 1 && ([3, 2].includes(Number(this.portOrg))) && (row.approvalSts < 2)) {
        this.$Modal.info({
          title: '温馨提示',
          content: '账单运营待确认，暂不可查看哦，请待运营确认再次查看详情！'
        });

        return null;
      }
      const { eduId } = this.searchParameter.data;
      const { portOrg, tableType } = this.searchParameter;

      const detailsData = encodeURIComponent(JSON.stringify({
        ...row, ...this.getJmupData(row)
      }));
      switch (tableType) {
        case 1:
          this.handleRoute('financeCenter_settlement_org_details', { detailsData });
          break;
        case 2:
          this.handleRoute('financeCenter_settlement_sch_details', { detailsData });
          break;
        case 3:
          this.handleRoute('financeCenter_settlement_edu_details', { detailsData, type: 1 });
      }
    }
  },
  filters: {
    initApprovalSts(val) {
      return getApprovalSts(val);
    },
    initSettleSts(v) {
      const map = {
        0: '未结算',
        1: '已结算',
        2: '待结算',
        3: '结算中'
      };
      return (v || v === 0) ? map[Number(v)] : '';
    },
    initBankId(v) {
      const map = {
        '0': '微信商户',
        '10001': '平安银行',
        '10002': '花都工行',
        '10003': '中山工行'
      };
      return (v || v === 0) ? map[Number(v)] : '';
    },
    initSettleCycle(v) {
      const map = {
        1: '按月考勤节次',
        2: '按固定时长'

      };
      return (v || v === 0) ? map[Number(v)] : '';
    }

  }

};
</script>

<style lang="scss" scoped >
.settlement-box {
}
</style>
